import { render, staticRenderFns } from "./ReportRangeSelectorLegend.vue?vue&type=template&id=66fd946a&"
import script from "./ReportRangeSelectorLegend.vue?vue&type=script&lang=js&"
export * from "./ReportRangeSelectorLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66fd946a')) {
      api.createRecord('66fd946a', component.options)
    } else {
      api.reload('66fd946a', component.options)
    }
    module.hot.accept("./ReportRangeSelectorLegend.vue?vue&type=template&id=66fd946a&", function () {
      api.rerender('66fd946a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/report/ReportRangeSelector/ReportRangeSelectorLegend.vue"
export default component.exports